export const colors = {
    black: "#15151F",
    white: "#FFFFFF",
    gray: "#757575",
    blue: "#5068A7",
    lightblue: "#F5F8FF",
    error: "#BA0001"
}
